<mat-card>
  <mat-card-content>
    <div class="header">
      <b>LOGIN</b>
    </div>
    <form (ngSubmit)="loginUser()" name="loginForm" [formGroup]="loginForm">
      <small class="text-danger">{{msg}}</small>
      <div class="email-input">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Username</mat-label>
          <input formControlName="username" matInput required name="username" [(ngModel)]="user.username">
          <mat-error *ngIf="loginForm.get('username').errors?.required">
             Username is required
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <a href="/resetPassword"><span class="aLink">
            Forgot Password?
        </span></a>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Password</mat-label>
          <input formControlName="password" matInput [type]="hide ? 'password' : 'text'" required name="password" [(ngModel)]="user.password"/>
          <button type="button"
                  mat-icon-button
                  matSuffix
                  (click)="hide = !hide"
                  [attr.aria-label]="'Hide Password'"
                  [attr.aria-pressed]="hide">
              <mat-icon>{{ hide?"visibility_off":"visibility" }}</mat-icon>
            </button>
            <mat-error *ngIf="loginForm.get('password').errors?.required">
              Required Password
            </mat-error>
        </mat-form-field>
      </div>
      <button mat-flat-button color="primary">Login</button>
      <p class="login-help">
        Staff and admin accounts are created by your school administrator (Teachers or Profile → User directory). Student access is managed separately from Students.
      </p>
    </form>
  </mat-card-content>
</mat-card>
